import { Component, inject, Input } from '@angular/core';
import { Observable } from 'rxjs';

import {
  BrowseMode,
  ModeNamesEnum,
  MODES,
} from 'app/modules/browse/models/browse-mode';
import { Sport } from 'app/modules/browse/models/sport';
import { ModeStore } from 'app/modules/browse/store/mode/mode.store';
import { SportStore } from 'app/modules/browse/store/sport/sport.store';
import { ScrollingService } from 'app/services/scrolling.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, AsyncPipe } from '@angular/common';
import { HorizontalScrollerComponent } from '../../../components/horizontal-scroller/horizontal-scroller.component';
import { SportSelectorComponent } from '../../../components/sport-selector/sport-selector.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-catalog-toolbar',
  templateUrl: './catalog-toolbar.component.html',
  styleUrls: ['./catalog-toolbar.component.scss'],
  standalone: true,
  imports: [
    SportSelectorComponent,
    HorizontalScrollerComponent,
    NgClass,
    AsyncPipe,
    TranslateModule,
    RouterLink,
  ],
})
export class CatalogToolbarComponent {
  @Input() isFixed: boolean = false;
  @Input() isHome: boolean = true;

  private scrollingService: ScrollingService = inject(ScrollingService);
  private sportStore: SportStore = inject(SportStore);
  private modeStore: ModeStore = inject(ModeStore);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  sports$: Observable<Sport[]> = this.sportStore.sports$;
  selectedSport$: Observable<Sport> = this.sportStore.selectedSport$;
  modes$: Observable<BrowseMode[]> = this.modeStore.modes$;
  selectedMode$: Observable<BrowseMode> = this.modeStore.selectedMode$;

  ngOnInit(): void {
    this.activatedRoute.fragment.subscribe((fragment: string) => {
      const mode = (modeName: ModeNamesEnum): BrowseMode =>
        MODES.find((mode: BrowseMode) => mode.name === modeName);

      if (!fragment) return;

      switch (fragment) {
        case 'workout':
        case 'structured-trainings': {
          this.modeStore.setSelectedMode(mode(ModeNamesEnum.Workouts));
          break;
        }
        case 'coaching':
        case 'coached-trainings': {
          this.modeStore.setSelectedMode(mode(ModeNamesEnum.Coachings));
          break;
        }
        case 'motion':
        case 'videos': {
          this.modeStore.setSelectedMode(mode(ModeNamesEnum.Videos));
          break;
        }
        case 'gps-tracks': {
          this.modeStore.setSelectedMode(mode(ModeNamesEnum.Gps));
          break;
        }
        case 'my-library': {
          this.modeStore.setSelectedMode(mode(ModeNamesEnum.Library));
          break;
        }
      }

      setTimeout(() =>
        this.scrollingService.detectChangesAndScrollSmoothlyTo('scrollLandmark')
      );
    });
  }

  onChangeSport(sport: Sport): void {
    this.sportStore.setSelectedSport(sport);

    if (this.isHome) {
      return window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    this.scrollingService.detectChangesAndScrollSmoothlyTo('scrollLandmark');
  }

  onChangeMode(mode: BrowseMode): void {
    this.router.navigate([], {
      queryParams: { location: null },
      queryParamsHandling: 'merge',
      fragment: mode.name,
    });
    this.modeStore.setSelectedMode(mode);
    this.scrollingService.detectChangesAndScrollSmoothlyTo('scrollLandmark');
  }
}
